<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">费用单据</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">费用类型：</span>
            <Select v-model="expenseType" :datas="expenseTypeOptions" keyName="key" titleName="title"
                    :deletable="true" style="width:140px" @change="loadList"></Select>
            <input type="text" v-model="keyword" placeholder="事由/单据编号" class="input-small" @keyup.enter="loadList">
            <Button size="s" @click="loadList">刷新</Button>
            <span class="flex-spacer"></span>
            <Button color="primary" size="s" @click="add">新增</Button>
            <DropdownMenu button @click="triggerIo" :datas="ioMenus" size="s">导入/导出</DropdownMenu>
            <Button size="s" :disabled="!checkedList.length" @click="batchRemove">批量操作</Button>
            <Button size="s" :disabled="!checkedList.length" @click="generateVoucher">生成凭证</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:44px"><input type="checkbox" :checked="checkAll" @click="toggleAll"></th>
                    <th style="width:100px">日期</th>
                    <th style="min-width:140px">事由</th>
                    <th style="min-width:120px">类型</th>
                    <th style="min-width:110px">结算方式</th>
                    <th style="width:120px;text-align:right">单据金额(含税)</th>
                    <th style="width:100px;text-align:right">可抵税额</th>
                    <th style="width:120px;text-align:right">单据金额(不含税)</th>
                    <th style="min-width:90px">收款人</th>
                    <th style="min-width:90px">部门</th>
                    <th style="min-width:110px">备注</th>
                    <th style="min-width:110px">单据编号</th>
                    <th style="min-width:90px">关联凭证</th>
                    <th style="width:90px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td align="center"><input type="checkbox" v-model="item._checked" :disabled="!!item.voucherId"></td>
                    <td>{{item.billDate}}</td>
                    <td>{{item.reason}}</td>
                    <td>{{item.expenseType}}</td>
                    <td>{{item.settlementType}}</td>
                    <td align="right">{{item.amountInclTax|numFormat}}</td>
                    <td align="right">{{item.taxDeduction|numFormat}}</td>
                    <td align="right">{{item.amountExclTax|numFormat}}</td>
                    <td>{{item.payee}}</td>
                    <td>{{item.department}}</td>
                    <td>{{item.remark}}</td>
                    <td>{{item.billNo}}</td>
                    <td class="text-hover">{{item.voucherWord}}{{item.voucherCode||''}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length"><td :colspan="14" class="text-center padding">暂无数据</td></tr>
                <tr class="total" v-if="datas.length">
                    <td :colspan="5" align="center">小计</td>
                    <td align="right">{{sumIncl|numFormat}}</td>
                    <td align="right">{{sumTax|numFormat}}</td>
                    <td align="right">{{sumExcl|numFormat}}</td>
                    <td :colspan="6"></td>
                </tr>
                </tbody>
            </table>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id?'编辑':'新增'}}费用单据</div>
            <Form ref="form" v-width="460" :labelWidth="110" :model="form" :rules="rules">
                <FormItem label="单据编号"><input type="text" v-model="form.billNo"></FormItem>
                <FormItem label="单据日期" prop="billDate"><DatePicker v-model="form.billDate" format="yyyy-MM-dd"></DatePicker></FormItem>
                <FormItem label="费用事由" prop="reason"><input type="text" v-model="form.reason"></FormItem>
                <FormItem label="费用类型">
                    <Select v-model="form.expenseType" :datas="expenseTypeOptions" keyName="key" titleName="title" :deletable="false"></Select>
                </FormItem>
                <FormItem label="结算方式">
                    <Select v-model="form.settlementType" :datas="settlementTypeOptions" keyName="key" titleName="title" :deletable="false"></Select>
                </FormItem>
                <FormItem label="含税金额" prop="amountInclTax">
                    <NumberInput v-model="form.amountInclTax" :precision="2" :min="0" @change="calcExcl"></NumberInput>
                </FormItem>
                <FormItem label="可抵税额">
                    <NumberInput v-model="form.taxDeduction" :precision="2" :min="0" @change="calcExcl"></NumberInput>
                </FormItem>
                <FormItem label="不含税金额"><NumberInput v-model="form.amountExclTax" :precision="2" :min="0" :readonly="true"></NumberInput></FormItem>
                <FormItem label="部门"><input type="text" v-model="form.department"></FormItem>
                <FormItem label="员工"><input type="text" v-model="form.employee"></FormItem>
                <FormItem label="收款人"><input type="text" v-model="form.payee"></FormItem>
                <FormItem label="附件"><Button size="xs" @click="notOpen('上传附件')">上传</Button></FormItem>
                <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit(false)" :loading="loading">保存</Button>
                <Button color="primary" @click="submit(true)" :loading="loading" v-if="!form.id">保存并新增</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>

        <import-modal v-model="showImport" title="费用单据导入" templateUrl="/api/invoice-expense/template"
                      :import-fn="importExpense" @success="loadList"/>
    </app-content>
</template>

<script>
import ImportModal from '../../components/common/ImportModal';
import { exportXls } from '../../js/common/export';

const emptyForm = () => ({
    id: null, billNo: '', billDate: new Date(), reason: '', expenseType: '', settlementType: '',
    amountInclTax: 0, taxDeduction: 0, amountExclTax: 0, department: '', employee: '', payee: '', remark: ''
});

export default {
    name: 'Expense',
    components: { ImportModal },
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            datas: [], p1: ym, p2: ym, keyword: '', expenseType: null,
            expenseTypeOptions: [], settlementTypeOptions: [],
            showForm: false, loading: false, form: emptyForm(),
            showImport: false,
            ioMenus: [
                { title: '模板导入', key: 'openImport' },
                { title: '当前数据导出', key: 'exportCurrent' },
                { title: '全部数据导出', key: 'exportAll' }
            ],
            rules: { required: ['billDate', 'reason', 'amountInclTax'] }
        };
    },
    computed: {
        checkAll() { return this.datas.length > 0 && this.datas.every(d => d._checked); },
        checkedList() { return this.datas.filter(d => d._checked); },
        sumIncl() { return this.datas.reduce((s, d) => s + Number(d.amountInclTax || 0), 0); },
        sumTax() { return this.datas.reduce((s, d) => s + Number(d.taxDeduction || 0), 0); },
        sumExcl() { return this.datas.reduce((s, d) => s + Number(d.amountExclTax || 0), 0); }
    },
    methods: {
        fmtPeriod(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; },
        fmtDate(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; },
        calcExcl() {
            const incl = Number(this.form.amountInclTax || 0);
            const tax = Number(this.form.taxDeduction || 0);
            this.form.amountExclTax = (incl - tax).toFixed(2);
        },
        loadOptions() {
            this.$api.invoice.expense.options().then(({ data }) => {
                this.expenseTypeOptions = (data.expenseTypes || []).map(t => ({ key: t, title: t }));
                this.settlementTypeOptions = (data.settlementTypes || []).map(t => ({ key: t, title: t }));
                if (!this.form.settlementType && this.settlementTypeOptions.length) this.form.settlementType = this.settlementTypeOptions[0].key;
                this.loadList();
            });
        },
        loadList() {
            this.$api.invoice.expense.list({
                p1: this.fmtPeriod(this.p1), p2: this.fmtPeriod(this.p2),
                keyword: this.keyword || undefined, status: undefined
            }).then(({ data }) => {
                this.datas = (data || []).map(d => Object.assign({ _checked: false }, d));
            });
        },
        add() { const f = emptyForm(); if (this.settlementTypeOptions.length) f.settlementType = this.settlementTypeOptions[0].key; this.form = f; this.showForm = true; },
        edit(item) {
            const f = Object.assign(emptyForm(), item);
            f.billDate = item.billDate ? new Date(item.billDate) : new Date();
            this.form = f;
            this.showForm = true;
        },
        submit(keep) {
            if (!this.$refs.form.valid().result) return;
            this.calcExcl();
            const p = Object.assign({}, this.form);
            p.billDate = this.fmtDate(p.billDate);
            this.loading = true;
            this.$api.invoice.expense[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false;
                this.loadList();
                this.$Message.success('保存成功');
                if (keep) { const f = emptyForm(); if (this.settlementTypeOptions.length) f.settlementType = this.settlementTypeOptions[0].key; this.form = f; }
                else { this.showForm = false; }
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm('确认删除该单据?').then(() => {
                this.$api.invoice.expense.delete(item.id).then(() => this.loadList());
            });
        },
        batchRemove() {
            const ids = this.checkedList.map(d => d.id);
            this.$Confirm(`确认删除选中的 ${ids.length} 条记录?`).then(() => {
                Promise.all(ids.map(id => this.$api.invoice.expense.delete(id))).then(() => this.loadList());
            });
        },
        generateVoucher() {
            const ids = this.checkedList.map(d => d.id);
            this.$api.invoice.expense.generateVoucher(ids).then(({ msg }) => {
                this.$Message.success(msg || '已生成凭证');
                this.loadList();
            });
        },
        toggleAll() { const v = !this.checkAll; this.datas.forEach(d => { if (!d.voucherId) d._checked = v; }); },
        downloadTpl() { this.notOpen('导入/导出'); },
        notOpen(name) { this.$Message.info(`${name}功能暂未开放`); },
        triggerIo(key) { this[key].call(this); },
        openImport() { this.showImport = true; },
        importExpense(fd) {
            return this.$api.invoice.expense.importData(fd);
        },
        buildRows(list) {
            return (list || []).map(item => [item.billDate, item.reason, item.expenseType, item.settlementType,
                Number(item.amountInclTax || 0), Number(item.taxDeduction || 0), Number(item.amountExclTax || 0),
                item.payee, item.department, item.remark, item.billNo, `${item.voucherWord || ''}${item.voucherCode || ''}`]);
        },
        head() {
            return ['日期', '事由', '类型', '结算方式', '单据金额(含税)', '可抵税额', '单据金额(不含税)', '收款人', '部门', '备注', '单据编号', '关联凭证'];
        },
        totalOf(list) {
            const s = (list || []).reduce((o, i) => {
                o.i += Number(i.amountInclTax || 0); o.t += Number(i.taxDeduction || 0); o.e += Number(i.amountExclTax || 0);
                return o;
            }, { i: 0, t: 0, e: 0 });
            return ['合计', '', '', '', s.i, s.t, s.e, '', '', '', '', ''];
        },
        exportCurrent() {
            if (!this.datas.length) { this.$Message('暂无数据可导出'); return; }
            exportXls({
                name: `费用单据_${this.fmtPeriod(this.p1)}至${this.fmtPeriod(this.p2)}`,
                sheets: [{
                    name: '费用单据', head: this.head(), rows: this.buildRows(this.datas), totalRow: this.totalOf(this.datas),
                    widths: [100, 180, 120, 110, 130, 110, 140, 110, 110, 160, 130, 100],
                    types: ['s', 's', 's', 's', 'n', 'n', 'n', 's', 's', 's', 's', 's']
                }]
            });
        },
        exportAll() {
            this.$api.invoice.expense.list({ all: 1 }).then(({ data }) => {
                const list = data || [];
                if (!list.length) { this.$Message('暂无数据可导出'); return; }
                exportXls({
                    name: '费用单据_全部数据',
                    sheets: [{
                        name: '费用单据', head: this.head(), rows: this.buildRows(list), totalRow: this.totalOf(list),
                        widths: [100, 180, 120, 110, 130, 110, 140, 110, 110, 160, 130, 100],
                        types: ['s', 's', 's', 's', 'n', 'n', 'n', 's', 's', 's', 's', 's']
                    }]
                });
            });
        }
    },
    mounted() { this.loadOptions(); }
};
</script>

<style scoped lang="less">
.filter-bar {
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    .label { margin-left: 6px; }
    .flex-spacer { flex: 1; }
    .input-small { width: 160px; height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 8px; }
}

.grid {
    width: 100%; border-collapse: collapse; margin-top: 10px;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; height: 35px; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
    .total td { background-color: #f5f5f5; font-weight: bold; }
}

.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
.text-hover { cursor: pointer; }
</style>
